import {$authHost, $host} from ".";

export const indexServers = async () => {
    const {data} = await $authHost.get('api/v1/servers.php', {});
    return data;
};

export const getPlugins = async (serverId) => {
    const {data} = await $authHost.get('api/v1/serverPlugins.php/' + serverId, {});
    return data;
};

export const fetchInitialMessagesAPI = async (serverId) => {
    const {data} = await $authHost.get('api/v1/getChatMessages.php/' + serverId, {});
    return data;
};

export const updatePlugin = async (serverId, pluginId) => {
    const {data} = await $authHost.get('api/v1/updatePlugin.php/' + serverId + '/' + pluginId, {});
    return data;
};

export const getServerPluginEdit = async (server_id, plugin_id, addition_id) => {
    const {data} = await $authHost.post('api/v1/getServerPluginEdit.php', {server_id, plugin_id, addition_id},{withCredentials: true});
    return data;
};

export const getServerPlayers = async (serverId) => {
    const {data} = await $authHost.post('api/v1/getServerPlayers.php', {serverId},{withCredentials: true});
    return data;
};

export const updateServerPluginFile = async (server_id, plugin_id, addition_id, code) => {
    const {data} = await $authHost.post('api/v1/updateServerPluginFile.php', {server_id, plugin_id, addition_id, code},{withCredentials: true});
    return data;
};

export const enablePlugin = async (server_id, plugin_id, enable) => {
    const {data} = await $authHost.post('api/v1/enablePlugin.php', {server_id, plugin_id, enable},{withCredentials: true});
    return data;
};

export const pinnedPlugin = async (server_id, plugin_id, pinned) => {
    const {data} = await $authHost.post('api/v1/pinnedPlugin.php', {server_id, plugin_id, pinned},{withCredentials: true});
    return data;
};

export const installPlugin = async (server_id, plugin_id) => {
    const {data} = await $authHost.post('api/v1/installPlugin.php', {server_id, plugin_id},{withCredentials: true});
    return data;
};

export const deletePlugin = async (server_id, plugin_id) => {
    const {data} = await $authHost.post('api/v1/deletePlugin.php', {server_id, plugin_id},{withCredentials: true});
    return data;
};

export const createServer = async (server_name, server_desc, server_site, server_logo, server_size, server_seed,
                                                     server_play, server_port, query_port, rcon_port, rcon_passwd,
                                                     server_ip, server_login, server_passwd, ftp_login, ftp_passwd, oxide_pwd) => {
    const {data} = await $authHost.post('api/v1/createServer.php', {server_name, server_desc, server_site, server_logo, server_size, server_seed,
                                                                                server_play, server_port, query_port, rcon_port, rcon_passwd,
                                                                                server_ip, server_login, server_passwd, ftp_login, ftp_passwd, oxide_pwd},{withCredentials: true});
    return data;
};

export const sendRcon = async (server_id, command, type) => {

    const {data} = await $authHost.post('api/v1/sendRcon.php', {server_id, command, type}, {withCredentials: true});
    return data;
};

export const syncServer = async (serverId) => {
    const {data} = await $authHost.get('api/v1/syncServer.php/' + serverId, {});
    return data;
};

export const jobServer = async (server_id, job) => {
    const {data} = await $authHost.post('api/v1/jobServer.php', {server_id, job},{withCredentials: true});
    return data;
};

export const wipeServer = async (server_id) => {
    const {data} = await $authHost.post('api/v1/wipeServer.php', {server_id},{withCredentials: true});
    return data;
};

export const serversInfo = async () => {
    const {data} = await $host.get('api/v1/serversInfo.php', {});
    return data;
};

export const serverInfo = async (server_id) => {
    const {data} = await $host.get('api/v1/serversInfo.php/' + server_id, {});
    return data;
};

export const serverInfoAuth = async (server_id) => {
    const {data} = await $authHost.get('api/v1/serversInfoAuth.php/' + server_id, {withCredentials: true});
    return data;
};

export const statusServer = async (server_id) => {
    const {data} = await $authHost.post('api/v1/statusServer.php', {server_id},{withCredentials: true});
    return data;
};

export const indexServer = async (server_id) => {
    const {data} = await $authHost.post('api/v1/indexServer.php', {server_id},{withCredentials: true});
    return data;
};

export const getServerSettings = async (server_id) => {
    const {data} = await $authHost.post('api/v1/getServerSettings.php', {server_id},{withCredentials: true});
    return data;
};

export const updateServerSettings = async (server_id, settings) => {
    const {data} = await $authHost.post('api/v1/updateServerSettings.php', {server_id, settings},{withCredentials: true});
    return data;
};

export const getServerStats = async (server_id) => {
    const {data} = await $authHost.post('api/v1/getServerStats.php', {server_id},{withCredentials: true});
    return data;
};

export const restoreBackup = async (server_id) => {
    const {data} = await $authHost.post('api/v1/restoreBackup.php', {server_id},{withCredentials: true});
    return data;
};

export const createBackup = async (server_id) => {
    const {data} = await $authHost.post('api/v1/createBackup.php', {server_id},{withCredentials: true});
    return data;
};

export const listBackups = async (server_id) => {
    const {data} = await $authHost.post('api/v1/listBackups.php', {server_id},{withCredentials: true});
    return data;
};

export const downloadBackup = async (server_id, setDownloading) => {
    try {
        const response = await $authHost.post(
            'api/v1/downloadBackup.php',
            { server_id },
            {
                responseType: 'blob',
                withCredentials: true,
                onDownloadProgress: (progressEvent) => {
                    if (progressEvent.lengthComputable && setDownloading) {
                        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        console.log(`Загружено: ${percent}%`);
                    }
                },
            }
        );

        const contentType = response.headers['content-type'];
        if (contentType.includes('application/json')) {
            const text = await response.data.text();
            const json = JSON.parse(text);
            throw new Error(json.error || 'Ошибка при скачивании');
        }

        let filename = 'backup.tar.gz';
        const disposition = response.headers['content-disposition'];
        if (disposition) {
            const match = disposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) filename = match[1];
        }

        const blob = new Blob([response.data], { type: contentType });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    } catch (e) {
        throw e;
    }
};